// extracted by mini-css-extract-plugin
module.exports =  {"link":"link-FrL1t","label":"label-PJvSJ"};